import { AbpOAuthService } from '@abp/ng.oauth';
import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private readonly notificationsSubject = new Subject<any>();
  private readonly newNotificationsSubject = new Subject<any>();
  private readonly oktaSubject = new Subject<any>();

  private connection: signalR.HubConnection;
  private isConnectionEstablished = false;

  constructor(public abpOauthService: AbpOAuthService,) {
  }
  initializeConnection(token: any): void {
    if (!this.isConnectionEstablished) {
      const baseUrl = environment.oAuthConfig.issuer;
      const defaultUrl = `${baseUrl}signalr-hubs/messaging`;

      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(defaultUrl, {
          accessTokenFactory: () => token
        })
        .withAutomaticReconnect([0, 2000, 5000, 10000])
        .build();

      this.connection
        .start()
        .then(() => {
          this.isConnectionEstablished = true;
          this.registerMessageHandler();
          this.registerMessageNewHandler();
          this.logoutFromAll();
        })
    }
  }

  private logoutFromAll() {
    if (this.connection) {
      this.connection.on('LogoutAllTabs', (message: any) => {
        this.abpOauthService.logout();
      });
    }
  }

  private registerMessageHandler(): void {
    if (this.connection) {
      this.connection.on('ReceiveMessage', (message: any) => {
        this.notificationsSubject.next(message);
      });
    }
  }
  private registerMessageNewHandler(): void {
    if (this.connection) {
      this.connection.on('ReceiveMessageNew', (message: any) => {
        this.newNotificationsSubject.next(message);
      });
    }
  }
  public registerOktaHandler(): void {
    if (this.connection) {
      this.connection.on('okta', (obj: any) => {
        this.oktaSubject.next(obj);
      });
    }
  }
  getNotifications(): Observable<any> {
    return this.notificationsSubject.asObservable();
  }
  getNewNotifications(): Observable<any> {
    return this.newNotificationsSubject.asObservable();
  }
  getOktaNotifications(): Observable<any> {
    return this.oktaSubject.asObservable();
  }
}